import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "modal-import-excel",
  class: "modal p-0"
}
const _hoisted_2 = { class: "modal__content modal__content--lg" }
const _hoisted_3 = { class: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-base mr-auto" }, "Import File Excel", -1)
const _hoisted_5 = { class: "px-3 md:px-5 py-3" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col items-center"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "mt-2 text-sm" }
const _hoisted_10 = { class: "flex flex-col sm:flex-row items-center mt-3 hidden" }
const _hoisted_11 = { class: "flex flex-col w-10/12" }
const _hoisted_12 = { class: "flex items-center mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Maks Ukuran File Banner = 2MB.", -1)
const _hoisted_14 = { class: "px-5 py-3 text-center border-t border-gray-200 dark:border-dark-5" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_xIcon = _resolveComponent("xIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "javascript:;",
          class: "right-0 top-0",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$gpf.hideModal('#modal-import-excel')))
        }, [
          _createVNode(_component_xIcon, { class: "w-6 h-6 text-gray-500" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          onDrop: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleFile($event, 'drop')), ["prevent"])),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.chooseExcel())),
          class: "w-full min-h-48 border-dashed border-2 border-gray-500 rounded flex justify-center items-center cursor-pointer"
        }, [
          (_ctx.allData.length === 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_6, " CLick to Upload File or Drag File over. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: '/icon-svg/excel-logo.svg',
                  alt: "excel-logo",
                  class: "w-20"
                }, null, 8, _hoisted_8),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.fileName) + " - " + _toDisplayString(_ctx.allData.length) + " total data. ", 1)
              ]))
        ], 32),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("input", {
                type: "file",
                class: "button w-10 border flex-1 hidden",
                placeholder: "Banner",
                id: "fileImportExcel",
                accept: ".xlsx, .xls",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleFile($event, 'select')))
              }, null, 32),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.chooseExcel())),
                class: "button bg-theme-1 hover:bg-primary text-white w-28 whitespace-nowrap"
              }, " Choose File ")
            ]),
            _hoisted_13
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          type: "button",
          class: "button w-20 bg-theme-6 text-white mr-2",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$gpf.hideModal('#modal-import-excel')))
        }, " Close "),
        _createElementVNode("button", {
          type: "button",
          class: "button w-20 bg-theme-1 text-white",
          disabled: _ctx.allData.length === 0,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.uploadExcel()))
        }, " Upload ", 8, _hoisted_15)
      ])
    ])
  ]))
}